import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';

const successIcon = require('./success.svg') as string;

export interface IEntryToShowSuccessModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const EntryToShowSuccessModal = ({ isOpen, closeModal }: IEntryToShowSuccessModalProps) => {
  return (
    <ModalWindow
      onClose={closeModal}
      open={isOpen}
      content={
        <div className={styles['container']}>
          <img src={successIcon} />
          <h1 className={styles['title']}>Поздравляем!</h1>
          <div className={styles['text']}>Вы записались на просмотр</div>
          <Button size="XS" onClick={closeModal}>
            Хорошо
          </Button>
        </div>
      }
    />
  );
};
